import {Component} from "@angular/core";
import {ContactEntityModel} from "../../contact-entity.model";
import {EditService} from "../../../framework/entity/edit/edit-page/edit.service";

@Component({
    selector: "wbo-contact-edit-delivery-takeaway",
    templateUrl: "./contact-edit-delivery-takeaway.component.html"
})
export class ContactEditDeliveryTakeawayComponent {
    constructor(public model: ContactEntityModel, public editService: EditService) {
    }
}
